/**
 * RouteErrorBoundary
 *
 * Wraps the routed PAGE so a render crash shows a readable error instead of
 * unmounting the entire app (which presents as a blank white screen that only
 * a manual refresh recovers from).
 *
 * The boundary is keyed on the current pathname so it remounts — and therefore
 * clears its error state — as soon as the user navigates somewhere else.
 *
 * NAV-6.1: this MUST wrap only the page (Outlet), never <Routes> or MainLayout.
 * The pathname key remounts its children; wrapping the shell made every in-app
 * nav look like a full reload (sidebar and header disappeared, then the
 * password-reset check showed a full-screen "Loading...").
 */

import React from "react";
import { useLocation } from "react-router-dom";
import { ErrorBoundary } from "./ErrorBoundary";

export function RouteErrorBoundary({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  return <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>;
}

export default RouteErrorBoundary;
